import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { ArrowUpRight } from "lucide-react";
import AppButton from "../../shared/AppButton";
import { teamMembers } from "@/data/TeamData";
const TeamOutroCard = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = String(teamMembers.length).padStart(2, "0");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const memberCount = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = teamMembers.reduce(_temp, 0);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const yearsCombined = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [{
      n: memberCount,
      l: "Members"
    }, {
      n: `${yearsCombined}+`,
      l: "Yrs Combined"
    }, {
      n: "\u221E",
      l: "Ideas"
    }];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const stats = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-sm font-semibold uppercase tracking-[0.25em] text-primary">The whole crew</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="space-y-6">{t3}<h3 className="font-black uppercase leading-[0.92] tracking-tighter text-4xl md:text-5xl xl:text-6xl">SIX MINDS. <br /> ONE MISSION.</h3><p className="max-w-sm text-base text-muted-foreground">Every project we ship is built by the people you just met — strategy, design and engineering, under one roof.</p></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex -space-x-3">{teamMembers.map(_temp2)}</div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex gap-10">{stats.map(_temp3)}</div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="grid w-full grid-cols-1 gap-10 md:grid-cols-2 md:items-center md:gap-12">{t4}<div className="space-y-8">{t5}{t6}<AppButton href="/career" className="w-48" buttonClass="h-11"><span>Join the team</span><ArrowUpRight className="h-4 w-4" /></AppButton></div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};
export default TeamOutroCard;
function _temp(sum, m) {
  return sum + (parseInt(m.experience, 10) || 0);
}
function _temp2(member) {
  return <div key={member.id} className="relative h-14 w-14 overflow-hidden rounded-full border-2 border-white ring-1 ring-black/10"><Image src={member.image} alt={member.name} fill={true} sizes="56px" className="object-cover" /></div>;
}
function _temp3(s) {
  return <div key={s.l}><p className="font-black leading-none tracking-tighter text-4xl">{s.n}</p><p className="mt-1 text-xs uppercase tracking-[0.2em] text-muted-foreground">{s.l}</p></div>;
}